import awsdk from 'awsdk';
import { Authentication, Consumer } from 'lib/amwell/sdk/types';
import BaseService from './BaseService';
import { errors } from '../constants';
import AwsdkError from '../errors/AwsdkError';
import ValidationError from '../errors/ValidationError';

export default class AuthenticationService extends BaseService {
  async authenticateWithToken(token: string): Promise<Authentication> {
    const key = this.authenticateWithToken.name;

    try {
      const res = await this.sdk.authenticationService.authenticateMutualAuthWithToken(token);

      if (res.needsToCompleteRegistration) {
        throw errors.NOT_REGISTERED;
      }

      return res;
    } catch (err) {
      throw new AwsdkError(key, err);
    }
  }

  async clearAuthentication(consumer: Consumer): Promise<boolean> {
    try {
      await this.sdk.authenticationService.clearAuthentication(consumer);
      return true;
    } catch (err) {
      return false;
    }
  }

  async requestPasswordReset(email: string, lastName: string, dob: Date): Promise<boolean> {
    const key = this.requestPasswordReset.name;

    try {
      return await this.sdk.authenticationService.requestPasswordReset(email, lastName, dob);
    } catch (err) {
      if (
        err instanceof awsdk.AWSDKError &&
        err.errorCode === awsdk.AWSDKErrorCode.validationErrors
      ) {
        throw new ValidationError(key, err.errors);
      }
      throw new AwsdkError(key, err);
    }
  }
}
